import { useState } from 'react';
import { useTestimonials } from '../api/queries';

interface TestimonialsData {
  eyebrow?: string;
}

/**
 * Guest quotes. Only testimonials a staff member has published are returned by the API —
 * unverified sample quotes stay unpublished, so this section simply does not render
 * rather than presenting invented reviews as real.
 */
export function TestimonialsBlock({ data }: { data: TestimonialsData }) {
  const { data: testimonials, isLoading } = useTestimonials();
  const [index, setIndex] = useState(0);

  const items = testimonials ?? [];
  if (isLoading || items.length === 0) return null;

  const active = items[index % items.length];

  return (
    <section className="sz-testimonials" aria-label="Guest testimonials">
      <div className="sz-testimonials__inner">
        <p className="sz-eyebrow">{data.eyebrow ?? 'Guests Say'}</p>
        <blockquote className="sz-testimonials__quote" aria-live="polite">
          “{active.quote}”
        </blockquote>
        <p className="sz-testimonials__author">{active.author}</p>

        {items.length > 1 && (
          <div className="sz-carousel-dots sz-testimonials__dots">
            {items.map((item, dotIndex) => (
              <button
                key={item.id}
                type="button"
                className="sz-carousel-dot sz-carousel-dot--round"
                data-active={dotIndex === index}
                aria-label={`Show testimonial from ${item.author}`}
                aria-current={dotIndex === index}
                onClick={() => setIndex(dotIndex)}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
